export const samples = {
    "C4" : "chimeC.mp3"
}
